import { Paper, Stack } from "@mui/material";
import React from "react";
//TODO: globalize the name of this wrapper e.g. PaperWrapper
//TODO: Check if this is used
export default function Wrapper({
  children,
  direction = "row",
  noPaper = false,
  hoverEffect = false,
  justifyContent="space-between",
  alignItems="center",
  ...rest
}) {
  const hoverStyles = {
    borderRadius: "8px",
    padding: 1,
    transition: "background-color 0.2s ease",
    "&:hover": {
      cursor: "pointer",
    },
  };

  if (noPaper) {
    return (
      <Stack
        {...rest}
        width={"100%"}
        direction={direction}
        justifyContent={justifyContent}
        alignItems={alignItems}
        display={"flex"}
        sx={hoverEffect ? hoverStyles : null}
      >
        {children}
      </Stack>
    );
  }
  return (
    <Paper sx={{ p: 1.5, width: "100%", ...hoverStyles }}>
      <Stack
        {...rest}
        direction={direction}
        justifyContent={justifyContent}
        alignItems={alignItems}
        display={"flex"}
      >
        {children}
      </Stack>
    </Paper>
  );
}
